import React from 'react';
import styled from 'styled-components';

import SvgAddIcon from 'assets/add-icon';
import { CircleButton } from 'components/core/button';

type QuickAddButtonProps = {
  onClick: () => void;
  productName: string;
};

export const QuickAddButton = ({ onClick, productName }: QuickAddButtonProps): JSX.Element => {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
    e.preventDefault();
    onClick();
  };

  return (
    <StyledCircleButton onClick={handleClick} aria-label={`Add ${productName} to cart`} data-testid='quick-add-button'>
      <SvgAddIcon />
    </StyledCircleButton>
  );
};

const StyledCircleButton = styled(CircleButton)`
  color: ${({ theme }) => theme.colors.white};
  padding: 0; // padding was being added from webkit, causing the icon to be smaller on iOS so we need to explicitly set it ourselves.
  position: absolute;
  right: 10px;
  top: 0;

  ${({ theme }) => theme.breakpoints.up('sm')} {
    top: 10px;
  }
`;
